import * as _ from "lodash"
import {IHierarchyStructure, IHierarchyStructureLevel} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {WB_HierarchyLevelRow} from "../PA.Core/PAdbSchemaRows";

export class GenericLevel
    implements IHierarchyStructureLevel
{
    private _hierStructure: IHierarchyStructure
    private _levelId: string
    private _levelName: string
    private _levelDepth: number

    // typing properties
    private _levelUnique: boolean
    private _wbEntityId: number
    private _wbAttributeMId: number
    private _wbEntityId_Ent: number

    private _bDelete: boolean

    // Create on Save
    private hierLevelRow: WB_HierarchyLevelRow

    constructor(structure: IHierarchyStructure,
                options?: {hierLvlRow?: WB_HierarchyLevelRow, clone?: IHierarchyStructureLevel })
    {
        this._hierStructure = structure
        this._bDelete = false
        this.hierLevelRow = options?.hierLvlRow
        this._levelUnique = false
        this._wbEntityId = 0
        this._wbAttributeMId = 0
        this._wbEntityId_Ent = 0

        this._levelId = ""
        this._levelName = ""
        this._levelDepth = 0

        if(!_.isEmpty(this.hierLevelRow)){
            this._levelId = this.hierLevelRow.cif.LEVEL_ID
            this._levelName = this.hierLevelRow.cif.LEVEL_NAME
            this._levelDepth = this.hierLevelRow.cif.LEVEL_DEPTH
            this._levelUnique = (this.hierLevelRow.cif.UNIQUE_IND == '1')
            this._wbEntityId = this.hierLevelRow.cif.WB_ENTITY_ID
            this._wbAttributeMId = this.hierLevelRow.cif.WB_ATTRIBUTEM_ID
            this._wbEntityId_Ent = this.hierLevelRow.cif.WB_ENTITY_ID_ENTERPRISE
        }

        if(!_.isEmpty(options?.clone)){
            let cln = options.clone
            this._levelId = cln.levelId
            this._levelName = cln.levelName
            this._levelDepth = cln.levelDepth
            this._levelUnique = cln.levelUnique
            this._wbEntityId = cln.levelEntityTypeId
            this._wbAttributeMId = cln.levelEntityAttributeId
            this._wbEntityId_Ent = cln.levelEnterpriseEntityTypeId
        }

    }

    get hierarchy(): IHierarchyStructure {
        return this._hierStructure
    }

    get levelId(): string {
        return this._levelId
    }

    get levelName(): string {
        return this._levelName
    }

    get levelDepth(): number {
        return this._levelDepth
    }

    setLevelId(id: string): void {
        this._levelId = id
    }

    setLevelName(name: string): void {
        this._levelName = name
    }

    setLevelDepth(depth: number): void {
        this._levelDepth = depth
    }


    //-- Typing Properties

    get levelUnique(): boolean {
        return this._levelUnique
    }

    get levelEntityTypeId(): number {
        return this._wbEntityId
    }

    get levelEntityAttributeId(): number {
        return this._wbAttributeMId
    }

    get levelEnterpriseEntityTypeId(): number {
        return this._wbEntityId_Ent
    }

    setLevelUnique(levelUnique: boolean): void {
        this._levelUnique = !!levelUnique
    }

    setLevelEntityType(wbEntityId: number): void {
        this._wbEntityId = wbEntityId || 0
    }

    setLevelEntityAttribute(wbAttributeMId: number): void {
        this._wbAttributeMId = wbAttributeMId || 0
    }

    setLevelEnterpriseEntityType(wbEntityId: number): void {
        this._wbEntityId_Ent = wbEntityId || 0
    }



    //-- Storage Properties
    get isActive(): boolean {
        return !this._bDelete
    }

    get isActiveNew(): boolean {
        return (_.isEmpty(this.hierLevelRow) && !this._bDelete)
    }

    get isModified(): boolean {
        if (_.isEmpty(this.hierLevelRow))
            return false

        if (this._bDelete && !_.isEmpty(this.hierLevelRow))
            return true


        if (this.hierLevelRow.cif.LEVEL_ID != this._levelId)
            return true

        if (this.hierLevelRow.cif.LEVEL_NAME != this._levelName)
            return true

        if (this.hierLevelRow.cif.LEVEL_DEPTH != this._levelDepth)
            return true

        return false
    }


    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        // This should never be called
    }

}